(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.xo-product-info-content__add .xo-btn');
    if (!btn) return;
    if (btn.classList.contains('pps-added')) return;

    var toastContainer = document.getElementById('cart-toast-container');

    if (toastContainer) {
      var toastObserver = new MutationObserver(function() {
        toastObserver.disconnect();
        btn.classList.add('pps-added');
        setTimeout(function() { btn.classList.remove('pps-added'); }, 2000);
      });
      toastObserver.observe(toastContainer, { childList: true });
      setTimeout(function() { toastObserver.disconnect(); }, 5000);
    } else {
      var bodyObserver = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          for (var j = 0; j < mutations[i].addedNodes.length; j++) {
            var node = mutations[i].addedNodes[j];
            if (node.id === 'cart-toast-container' || (node.querySelector && node.querySelector('#cart-toast-container'))) {
              bodyObserver.disconnect();
              btn.classList.add('pps-added');
              setTimeout(function() { btn.classList.remove('pps-added'); }, 2000);
              return;
            }
          }
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() { bodyObserver.disconnect(); }, 5000);
    }
  }, true);
})();
